import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AiFillHome } from "react-icons/ai";
import { MdMenuBook } from "react-icons/md";
import { FaUser } from "react-icons/fa";

const NewBottomNav = () => {
  const location = useLocation();

  const navStyle = {
    position: "fixed",
    bottom: 0,
    width: "100%",
    background: "rgba(15,15,15,0.95)",
    backdropFilter: "blur(10px)",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "8px 0",
    zIndex: 999,
    borderTop: "1px solid rgba(255,255,255,0.1)",
  };

  const itemStyle = (path) => {
    const active = location.pathname === path;
    return {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textDecoration: "none",
      color: active ? "#ffd700" : "#2a81f3",
      fontSize: "12px",
      fontWeight: "bold",
      transition: "0.3s",
    };
  };

  const iconStyle = (path) => ({
    fontSize: "22px",
    marginBottom: "2px",
    color: location.pathname === path ? "#ffd700" : "#2a81f3",
  });

  return (
    <div style={navStyle}>
      
      {/* HOME */}
      <Link to="/" style={itemStyle("/")}>
        <AiFillHome style={iconStyle("/")} />
        Home
      </Link>

      {/* COURSES */}
      <Link to="/myCources" style={itemStyle("/myCources")}>
        <MdMenuBook style={iconStyle("/myCources")} />
        Courses
      </Link>

      {/* PROFILE */}
      <Link to="/profile" style={itemStyle("/profile")}>
        <FaUser style={iconStyle("/profile")} />
        Profile
      </Link>

    </div>
  );
};

export default NewBottomNav;